/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

import { formatBytes } from '@utils/general'

import './style.scss';

const CardDocument = ({ file, removeFile, preview }) => {
  const [nameFile, setName] = useState('')
  const [extension, setExtension] = useState('')
  const [isImage, setIsImage] = useState(false)

  useEffect(() => {
    setName(file.name)
    setExtension(file.name.split('.').pop())
    validateIsImage()
  },[])
  
  const validateIsImage = () => {
    let _isImage = false
    const { type } = file
    if (type) {
      if (type.split('/')[0] === 'image') _isImage = true
    }
    setIsImage(_isImage)
  }

  const previewFile = () => {
    const localUrl = URL.createObjectURL(file);


    if (extension === 'pdf') {
      return <iframe src={localUrl} className="card-component-iframe" title={nameFile}/>;
    }
    if (isImage) {
      return <img src={localUrl} className="card-component-image" alt={nameFile}/>;
    }
    return <i className="pi pi-file" style={{fontSize: '7rem'}}/>
  };
  const footer = (
    <div className="p-text-right">
      { removeFile && (
        <Button
          icon="pi pi-trash"
          type="button"
          className="p-button-outlined p-button-secondary p-mr-2 p-mb-1"
          onClick={removeFile}
        />
      )}
      { preview && (isImage || extension === 'pdf') && (
        <Button
          icon="pi pi-search-plus"
          type="button"
          className="p-button-outlined p-button-secondary p-mr-2 p-mb-1"
          onClick={preview}
        />
      )}
    </div>
  );

  return (
    <Card footer={footer} className="card-file">
      <div className="p-d-flex p-flex-column p-jc-center p-ai-center">
        <div className="card-component-file">{previewFile()}</div>
        <div className="card-component-description p-d-flex p-flex-column p-jc-center p-ai-center">
          <small className="p-text-light p-text-center"><div
          className="p-mb-1 demo-container p-text-nowrap p-text-truncate p-text-center"
          style={{ width: '10rem' }}
          > {nameFile} - {extension}</div></small>
          <small className="p-text-light"> ({formatBytes(file.size)}) </small>
        </div>  
      </div>
    </Card>
  );
};

CardDocument.prototype = {
  file: PropTypes.any,
  removeFile: PropTypes.func,
  preview: PropTypes.preview,
};

export default CardDocument;
